import store from "@/store/index";
import axios from "axios";

function checkDuplicateIdcard(idcard) {
  return new Promise((resolve, reject) => {
    const config = {
      url: `${process.env.VUE_APP_BASE_API}member/getMemberSurveyById`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${store.getters["userAuth/getToken"]}`,
        "Content-Type": `application/json; charset=utf-8`,
      },
      data: {
        member_nid: idcard,
      },
    };
    axios(config)
      .then((response) => {
        let returnResult;
        if (response.data && response.data.national_id == idcard) {
          returnResult = response.data;
        }
        resolve(returnResult);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export { checkDuplicateIdcard };
